import styled from 'styled-components';

export const ModalContent = styled.div`
  z-index:10;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow:
    0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  max-width: 600px;
  width: 100%;

  @media (max-width: 768px) {
    align-self: flex-end;
    border-radius: 24px 24px 0 0;
    width: 100%;
    max-width: 100%;
    padding: 16px;
  }
`;

export const CelebrationIconWrapper = styled.div`
  margin-bottom: 8px;
`;

export const Heading = styled.h1`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  letter-spacing: normal;
  text-align: center;
  color: #475569;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 32px;
  }
`;

export const Description = styled.p`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #475569;
  margin: 0;
  max-width: 330px;
`;

export const CloseIconWrapper = styled.div`
  display: flex;
  align-self: flex-end;
  cursor: pointer;
  margin-bottom: 8px;

  * {
    pointer-events: none;
  }
`;
